import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgHyperlinlk() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M9 5H5a2 2 0 00-2 2v13a2 2 0 002 2h13a2 2 0 002-2v-4",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      d: "M11 14L22 3M14 3h8v8",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
}

export default SvgHyperlinlk;